export const Link = {
  baseStyle: {
  },
};
